const api = {
    url: process.env.REACT_APP_API_HOST,
    path: {
        login: 'login',
        logout: 'logout',
        register: 'register',
        forgotPassword: 'forgotpassword',
        resetPassword: '/resetPassword',
        order: 'order',
        userData: '/user',
        addressBook: 'addressbook',
        subscriptions: '/subscriptions',
        review: 'review',
        customer: 'customer',
        settings: 'settings',
    },
};

export default api;
